import { Nominee } from '../../../proto/generated/trading-bridge'

export enum NomineeChangeRequestStatus {
    UNKNOWN = 0,
    PENDING = 1,
    APPROVED = 2,
    REJECTED = 3
}

export interface NomineeChangeRequest {
    id: number
    status: NomineeChangeRequestStatus
    nominees: Nominee[]
    requestedAt: number
    rejectionReason?: string
}

export const isPendingNomineeChangeRequest = (request: NomineeChangeRequest | null | undefined): boolean =>
    request?.status === NomineeChangeRequestStatus.PENDING
